export const COLUMN_TYPES = {
    DEFAULT: 1,
    TAGS: 2,
    ICON: 3,
    ACTION: 4,
    TOOLTIP: 5,
    AVATAR: 6,
};
